import * as Website from '../../Config/Website.js';
import * as PurposeScroll from './Modules/PurposeScroll.js';


const preinit = () => {

}

const init = () => {
  PurposeScroll.init();
}

const pageChanged = () => {
  PurposeScroll.init();
}

const resize = () => {
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}